/**
 * Русские подписи для служебных элементов Refine.
 *
 * Без i18n-провайдера библиотека подставляет английские значения по умолчанию
 * («Show», «Logout», «Create»), и панель выглядит наполовину переведённой.
 * Полноценная мультиязычность здесь не нужна — интерфейс модерации
 * одноязычный, поэтому достаточно словаря без библиотеки перевода.
 */
import type { I18nProvider } from "@refinedev/core";

const dictionary: Record<string, string> = {
  // Действия над ресурсами — используются в хлебных крошках и заголовках.
  "actions.list": "Список",
  "actions.create": "Создание",
  "actions.edit": "Редактирование",
  "actions.show": "Просмотр",
  "actions.clone": "Копирование",

  // Кнопки.
  "buttons.create": "Создать",
  "buttons.save": "Сохранить",
  "buttons.logout": "Выйти",
  "buttons.delete": "Удалить",
  "buttons.edit": "Изменить",
  "buttons.show": "Открыть",
  "buttons.list": "К списку",
  "buttons.cancel": "Отмена",
  "buttons.confirm": "Вы уверены?",
  "buttons.filter": "Фильтр",
  "buttons.clear": "Очистить",
  "buttons.refresh": "Обновить",
  "buttons.notAccessTitle": "Нет доступа",
  "buttons.undo": "Отменить",

  "table.actions": "Действия",

  // Уведомления.
  "notifications.success": "Готово",
  "notifications.error": "Ошибка (код {{statusCode}})",
  "notifications.undoable": "Отмена доступна ещё {{seconds}} сек.",
  "notifications.createSuccess": "Запись создана",
  "notifications.createError": "Не удалось создать запись (код {{statusCode}})",
  "notifications.deleteSuccess": "Запись удалена",
  "notifications.deleteError": "Не удалось удалить запись (код {{statusCode}})",
  "notifications.editSuccess": "Изменения сохранены",
  "notifications.editError": "Не удалось сохранить изменения (код {{statusCode}})",

  // Страницы ошибок и логина.
  "pages.error.info": "Страница не найдена",
  "pages.error.404": "Такой страницы нет",
  "pages.error.resource404": "Ресурс не найден",
  "pages.error.backHome": "На главную",
  "pages.login.signin": "Войти",
  "pages.login.title": "Вход в панель",

  "warnWhenUnsavedChanges": "Есть несохранённые изменения. Уйти со страницы?",

  // Названия ресурсов в меню и крошках.
  "photos.photos": "Фотографии",
  "quests.quests": "Квесты",
  "users.users": "Пользователи",
  "documentTitle.default": "ChronoGuessr Admin",
};

/** Подстановка значений вида {{statusCode}} в шаблон. */
function interpolate(template: string, options?: Record<string, unknown>): string {
  if (!options) return template;
  return template.replace(/\{\{(\w+)\}\}/g, (match, key: string) =>
    options[key] === undefined ? match : String(options[key]),
  );
}

export const i18nProvider: I18nProvider = {
  translate: (key, options, defaultMessage) => {
    const template = dictionary[key];
    if (template) return interpolate(template, options as Record<string, unknown>);

    // Неизвестный ключ отдаём как есть: пусть лучше в интерфейсе будет
    // английская подпись, чем пустое место.
    return (defaultMessage as string) ?? key;
  },
  changeLocale: async () => undefined,
  getLocale: () => "ru",
};
